import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Swiper from 'swiper/bundle'
gsap.registerPlugin(ScrollTrigger)

/**
 * ImageGallery component.
 * @author Dayne Coulson-Hoffacker
 */
export default class ImageGallery {
  /**
   * Constructs a new ImageGallery component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.globalDuration = options.globalDuration
    this.imageGallerySlider = this.element.querySelector('[data-component="image-gallery-slider"]')
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPrev = this.element.querySelector('[data-component="swiper-button-prev"]')
    this.swiperNext = this.element.querySelector('[data-component="swiper-button-next"]')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')

    var slider = new Swiper(this.swiperContainer, {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    })

    this.swiperPrev.addEventListener('click', () => {
      slider.slidePrev()
    })

    this.swiperNext.addEventListener('click', () => {
      slider.slideNext()
    })

    const imageGallerySliderTL = gsap.timeline({ paused: true })
    imageGallerySliderTL.to(this.imageGallerySlider, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')

    ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        imageGallerySliderTL.play()
      }
    })
  }
}


// WEBPACK FOOTER //
// ./components/section/image-gallery/index.js